module.exports = __webpack_public_path__ + "static/media/tel.96920346.jpg";